import React from 'react';
import { useEffect } from 'react';
import { useErrorContext } from '../../../context/ErrorContext';
import ErrorAlert from './ErrorAlert';

export default function ContextErrorAlert() {
  const { error, setError } = useErrorContext();

  useEffect(() => {
    return () => setError(undefined);
  }, [setError]);

  if (!error) {
    return null;
  }

  return (
    <ErrorAlert
      dismissable={true}
      titleText={error}
      onDismissed={() => setError(undefined)}
    />
  );
}
